// extracted by mini-css-extract-plugin
module.exports = {"label":"wWsKjV","radio":"zNuwAi","input":"K4bgTM"};